export default {
  data() {
    return {
      icons: {
        account: require('@/assets/icons/account.svg'),
        arrows: {
          dropdown: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 9L12 15L18 9" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
          left: `<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.93399 9.26666L0.667321 4.99999M0.667321 4.99999L4.93399 0.733328M0.667321 4.99999L11.334 5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
          right: `<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.06602 0.733337L11.3327 5M11.3327 5L7.06602 9.26667M11.3327 5H0.666016" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
        },
        back: require('@/assets/icons/back.svg'),
        book2: require('@/assets/icons/book.svg'),
        checkMark: require('@/assets/icons/check-mark.svg'),
        delete: require('@/assets/icons/delete.svg'),
        edit: require('@/assets/icons/edit.svg'),
        export: require('@/assets/icons/export.svg'),
        eyeClosed: require('@/assets/icons/eye-closed.svg'),
        forward: require('@/assets/icons/forward.svg'),
        graduationCap: require('@/assets/icons/graduation-cap.svg'),
        group: require('@/assets/icons/group.svg'),
        heart: require('@/assets/icons/_heart.svg'),
        info: require('@/assets/icons/info.svg'),
        input_info: require('@/assets/icons/input-info.svg'),
        lock: require('@/assets/icons/lock2.svg'),
        logout: require('@/assets/icons/logout.svg'),
        messageBalloons: require('@/assets/icons/message-balloons.svg'),
        paperPlane: require('@/assets/icons/paperaPlane.svg'),
        pause: require('@/assets/icons/pause.svg'),
        pencil: require('@/assets/icons/pencil.svg'),
        placeholder: {
          avatar: require('@/assets/avatar.svg'),
        },
        play: require('@/assets/icons/play.svg'),
        question: require('@/assets/icons/question-mark.svg'),
        rating_star: {
          active: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 1L8.48933 5.66667H13L9.41 8.41667L10.8993 13L7 10.1673L3.10067 13L4.59 8.41667L1 5.66667H5.51067L7 1Z" fill="#F2994A" stroke="#F2994A" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
          disabled: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 1L8.48933 5.66667H13L9.41 8.41667L10.8993 13L7 10.1673L3.10067 13L4.59 8.41667L1 5.66667H5.51067L7 1Z" fill="#E0E3E7" stroke="#E0E3E7" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
        },
        sections: require('@/assets/icons/sections.svg'),
        shield: require('@/assets/icons/shield.svg'),
        shoppingCart: require('@/assets/icons/shopping-cart.svg'),
        star: require('@/assets/icons/star-empty.svg'),
        stripe: require('@/assets/icons/stripe.svg'),
        thumbsUp: require('@/assets/icons/thumbs-up.svg'),
        uploader: {
          image: require('@/assets/icons/uploader-img.svg'),
          podcast: require('@/assets/icons/Podcast1.svg'),
          video: require('@/assets/icons/uploader-video.svg'),
        },
        wallet: require('@/assets/icons/wallet.svg'),
        yes: require('@/assets/icons/yes-solid.svg'),
      },
    };
  },
};
